<template>
	<div class="container-fluid p-4">
		<div class="row">
			<div class="col-md-6 text-center">
				<h2 class="fw-bolder fw-bold fs-1 mb-3">
					Instruções
				</h2>
				<p class="fw-bolder fs-5 text-gray-600">
					Se conseguir se ver na camera finalize o processo.
				</p>
				<p class="fw-bolder fs-5 text-gray-600">
					Se não conseguir retorno da camera entre em contato com o
					suporte.
				</p>
			</div>
			<div class="col-md-6">
				<div id="camera"></div>
			</div>
		</div>
		<div class="row mt-5">
			<div class="col-sm-12 col-md-6 my-2">
				<a class="btn btn-success gl-2 col-12" href="/dashboard/">
					<i class="fas fa-check-circle"></i>
					Confirmar
				</a>
			</div>
			<div class="col-sm-12 col-md-6 my-2">
				<a
					class="btn btn-danger col-12"
					href="https://tawk.to/chat/625712c2b0d10b6f3e6d6cfc/1g0i22iep">
					<i class="fas fa-exclamation-triangle"></i>
					Contato suporte
				</a>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
	import { onMounted } from 'vue';
	import { configFirstLicenseStore } from '../../stores/configFirstLicense';

	const config_first_license = configFirstLicenseStore();

	onMounted(() => {
		config_first_license.start_webcam();
	});
</script>
